import { TRACK_IDENTIFY, TRACK_PAGE, NOOP } from '../constants';
import { keys as queryKeys } from '../queries';
import createDebug from '../utils/debug';

const debug = createDebug('track-method');
const defaultInstance = {
  track: (...args) => debug('track', ...args),
  identify: (...args) => debug(TRACK_IDENTIFY, ...args),
  page: (...args) => debug(TRACK_PAGE, ...args),
};

export default function createTrackMethod(
  queryClient,
  getAnalytics = NOOP,
  errorLogger,
) {
  return (eventName, eventPayload) => {
    const throwError = (error) => {
      throw new Error(error);
    };

    const {
      track = throwError('track method missing'),
      identify = throwError('identify method missing'),
      page = throwError('page method missing'),
    } = getAnalytics() || defaultInstance;

    function addSessionMetadata(payload) {
      const trackingMetadata =
        queryClient.getQueryData(queryKeys.trackingSessionMetadata) || {};

      return {
        ...payload,
        ...trackingMetadata,
      };
    }

    switch (eventName) {
      case TRACK_IDENTIFY:
        identify(eventPayload.id, addSessionMetadata(eventPayload.data));
        return;

      case TRACK_PAGE:
        page(eventPayload.name, addSessionMetadata(eventPayload.properties));
        return;

      default:
        if (eventName) {
          /* this for investigation purpose only
           * should be reverted after ticket https://group-one.atlassian.net/browse/AP-1643
           * is resolved
           * PR is: https://github.com/shore-gmbh/app-shell/pull/new/AP-1643-check-mixpanel-data
           */

          if (eventName === 'services_edit_course_save_clicked') {
            const payloadWithMetadata = addSessionMetadata(eventPayload);

            if (!payloadWithMetadata.session_role) {
              errorLogger.log(
                new Error('Session role not found. Call in track-method.js:55'),
                {
                  payloadWithMetaData: JSON.stringify(payloadWithMetadata),
                },
              );
            }

            track(eventName, payloadWithMetadata);
          } else {
            track(eventName, addSessionMetadata(eventPayload));
          }
        }
    }
  };
}
